<template>
  <div style="margin-top: 30px">
    <el-form ref="form" :rules="rules" :model="form">
      <el-row>
        <el-col :span="4" class="formTitle"> 重新提交单据 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.isUnloadingConfirmStatusMsg }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 实际承运人姓名 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.driverName }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 实际承运人电话 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.driverPhone }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 车牌号 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.vehicleLicense }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 卸货吨位 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.unloadWeight }}吨</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 卸货数量 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.unloadQuantity }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 卸货时间 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.signTime }}</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 预估实际承运人费用 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.deliveryFeeDeserved }} 元</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 预估服务费 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.taxPayFee }} 元</el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 预估托运人费用 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item>{{ form.taxFee }} 元</el-form-item>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4" class="formTitle">
          <span class="hx">*</span>是否回单
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="isReceiptReturn">
              <el-radio-group v-model="form.isReceiptReturn">
                <el-radio :label="'0'"> 否 </el-radio>
                <el-radio :label="'1'"> 是 </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row v-if="form.isReceiptReturn == '1'">
        <el-col :span="4" class="formTitle">
          <span class="hx">*</span>回单号
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="receiptNum">
              <el-input v-model="form.receiptNum" />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="form.isReceiptReturn == '1'">
        <el-col :span="4" class="formTitle">
          <span class="hx">*</span>回单照片
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="receiptImg">
              <el-upload
                ref="receiptImgRef"
                :headers="headers"
                :action="uploadUrl"
                list-type="picture-card"
                :before-upload="beforeImgUpload"
                :on-success="handleReceiptImgSuccess"
                :on-remove="handleReceiptImgRemove"
                :limit="9"
              >
                <i class="el-icon-plus" />
              </el-upload>
            </el-form-item>
          </div>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="4" class="formTitle">
          <span class="hx">*</span>是否异常
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="isAbnormal">
              <el-radio-group v-model="form.isAbnormal">
                <el-radio :label="'0'"> 否 </el-radio>
                <el-radio :label="'1'"> 是 </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="form.isAbnormal == '1'">
        <el-col :span="4" class="formTitle">
          <span class="hx">*</span>其他费用
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item label="" style="margin-right: 15px">
              <el-input
                v-model.number="form.abnormalFee"
                placeholder="请输入异常费用"
                @input="
                  value =>
                    formFormatter.isInteger(
                      value,
                      oldValue,
                      form,
                      'abnormalFee',
                      true
                    )
                "
              >
                <template slot="prepend">
                  <div class="positive_negative">
                    <div
                      class="positive_btn"
                      :class="{ negative_btn: driftPriceType == '+' }"
                      @click="driftPriceType = '+'"
                    >
                      +
                    </div>
                    <div
                      class="positive_btn"
                      :class="{ negative_btn: driftPriceType == '-' }"
                      @click="driftPriceType = '-'"
                    >
                      -
                    </div>
                  </div>
                </template>
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="abnormalFee">
              <el-input
                v-model="form.abnormalFee"
                @input="
                  (value) => formFormatter.isFloor2(value,oldValue, form, 'abnormalFee')
                "
              />
            </el-form-item> -->
          </div>
        </el-col>
      </el-row>
      <el-row v-if="form.isAbnormal == '1'">
        <el-col :span="4" class="formTitle"> 备注 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="abnormalRemark">
              <el-input
                v-model="form.abnormalRemark"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="form.isAbnormal == '1'">
        <el-col :span="4" class="formTitle">
          <span class="hx" />异常照片
        </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="abnormalImg">
              <el-upload
                ref="abnormalImgRef"
                :headers="headers"
                :action="uploadUrl"
                list-type="picture-card"
                :before-upload="beforeImgUpload"
                :on-success="handleAbnormalImgSuccess"
                :on-remove="handleAbnormalImgRemove"
                :limit="9"
              >
                <i class="el-icon-plus" />
              </el-upload>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4" class="formTitle"> 费用总额 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple pdt">
            <el-form-item prop="extraFee">
              <el-input
                v-model="form.extraFee"
                type="number"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col :span="24">
          <el-table
            ref="xTable"
            resizable
            border
            :data="form.orderExtraFeeList"
            class="mytable"
          >
            <el-table-column width="50" type="index" label="序号" />
            <el-table-column width="108">
              <template v-slot:header>
                <span class="hx">*</span>费用名称
              </template>
              <template v-slot="{ row }">
                <el-select
                  v-model="row.extraFeeType"
                  placeholder="请选择"
                  size="mini"
                  @change="val => setFeeName(val, row)"
                >
                  <el-option
                    v-for="(v, k) in extraFeeType"
                    :key="k"
                    :value="v.code"
                    :label="v.name"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column width="108">
              <template v-slot:header> <span class="hx">*</span>金额 </template>
              <template v-slot="{ row }">
                <el-input
                  v-model="row.extraFeeAmount"
                  size="mini"
                  type="number"
                  step="0.01"
                  placeholder="请输入金额"
                  @change="saveExtraFee()"
                />
              </template>
            </el-table-column>
            <el-table-column width="108">
              <template v-slot:header>
                <span class="hx">*</span>收支类型
              </template>
              <template v-slot="{ row }">
                <el-select
                  v-model="row.extraPayType"
                  placeholder="请选择"
                  size="mini"
                  @change="saveExtraFee()"
                >
                  <el-option
                    v-for="(v, k) in extraPayType"
                    :key="k"
                    :value="k"
                    :label="v"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template v-slot="{ row }">
                <el-input v-model="row.extraFeeRemark" size="mini" />
              </template>
            </el-table-column>
            <el-table-column width="50">
              <template v-slot:header>
                <i
                  class="el-icon-plus"
                  style="padding: 0 6px; cursor: pointer"
                  @click="insertEvent(-1)"
                />
              </template>
              <template v-slot="{ row, $index }">
                <i
                  class="el-icon-minus"
                  style="padding: 0 6px; cursor: pointer"
                  @click="delRowEvent(row, $index)"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="4" class="formTitle"> 装货图片 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <!-- <img
              v-for="(v,k) in form.fillImageUrl"
              v-if="v&&v!=''"
              :key="k"
              style="width: 200px;max-height: 200px;"
              :src="v"
              alt
            /> -->
            <template v-for="(item, index) in form.fillImageUrl">
              <el-image
                v-if="item"
                :key="'img_' + index"
                style="width: 146px; max-height: 146px; margin: 2px"
                :src="item"
                :preview-src-list="form.fillImageUrl"
              />
            </template>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" class="formTitle"> 卸货图片 </el-col>
        <el-col :span="20">
          <div class="grid-content bg-purple">
            <template v-for="(item, index) in form.signImageUrl">
              <el-image
                v-if="item"
                :key="'img_' + index"
                style="width: 146px; max-height: 146px; margin: 2px"
                :src="item"
                :preview-src-list="form.signImageUrl"
              />
            </template>
            <!-- <img
              v-for="(v,k) in form.signImageUrl"
              v-if="v&&v!=''"
              :key="k"
              style="width: 200px;max-height: 200px;"
              :src="v"
              alt
            /> -->
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel"> 取 消 </el-button>
      <el-button type="primary" @click="allowFunc"> 同 意 </el-button>
      <el-button type="primary" @click="rejectFunc"> 拒 绝 </el-button>
    </div>
  </div>
</template>
<script>
import { OrderDetails, orderDetailFinish } from "@/api/transport";
import { getListDict } from "@/api/commonApi";
import { getToken } from "@/utils/auth";
export default {
  data() {
    var checkAbnormalFee = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("金额不能为空"));
      } else {
        if (value <= 0) {
          callback(new Error("请输入大于0的金额"));
        } else {
          callback();
        }
      }
    };
    return {
      driftPriceType: "+",
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000"
      },
      abnormalImage: [],
      receiptImage: [],
      fileList: [],
      pageType: "unloadAffirm",
      extraFeeType: {},
      extraPayType: { 0: "收入", 1: "支出" },
      form: {
        driverName: "",
        driverPhone: "",
        vehicleLicense: "",
        unloadWeight: "",
        coalUnitName: "",
        lastUnloadingTime: "",
        fillImageUrl: [],
        signImageUrl: [],

        isReceiptReturn: "0",
        receiptNum: "",
        receiptImg: "",
        isAbnormal: "0",
        abnormalFee: "",
        abnormalRemark: "",
        abnormalImg: "",
        extraFee: "",
        orderExtraFeeList: [],
        isUnloadingConfirmStatus: "",
        isUnloadingConfirmStatusMsg: "",
        deliveryFeeDeserved: "",
        taxPayFee: "",
        taxFee: ""
      },
      rules: {
        isAbnormal: [
          { required: true, message: "请选择是否异常", trigger: "blur" }
        ],

        abnormalFee: [
          {
            validator: checkAbnormalFee,
            message: "请输入异常费用",
            trigger: "blur"
          }
        ],

        // abnormalImg: [
        //   { required: true, message: "请上传异常照片", trigger: "blur" },
        // ],
        abnormalRemark: [{ max: 255, message: "不超过255字符" }]
      }
    };
  },
  // async created() {
  //   const dicts = await getDictByType("extraFeeType");
  //   // this.$set(this, "extraFeeType", dicts.extraFeeType);
  // },
  methods: {
    setFeeName(val, row) {
      const item = this.extraFeeType.find(item => item.code === val);
      row.extraFeeName = item ? item.name : "";
    },
    getExtraFeeTypeDict(branchCode) {
      getListDict({ types: "extraFeeType", branchCode: branchCode }).then(
        response => {
          this.extraFeeType = response.data[0].dictList;
        }
      );
    },
    init(entity) {
      this.form.code = entity.code;
      this.form.isReceiptReturn = entity.isReceiptReturn;
      this.form.receiptNum = entity.receiptNum;
      this.form.receiptImg = entity.receiptImg;
      this.form.isAbnormal = entity.isAbnormal;
      this.form.abnormalFee = entity.abnormalFee;
      this.form.abnormalRemark = entity.abnormalRemark;
      this.form.abnormalImg = entity.abnormalImg;
      this.form.extraFee = entity.extraFee;
      this.form.driverName = entity.driverName;
      this.form.driverPhone = entity.driverPhone;
      this.form.vehicleLicense = entity.vehicleLicense;
      this.form.unloadWeight = entity.unloadWeight;
      this.form.coalUnitName = entity.coalUnitName;
      this.form.lastUnloadingTime = entity.lastUnloadingTime;
      this.form.unloadQuantity = entity.unloadQuantity;
      this.form.signTime = entity.signTime;

      if (
        entity.isUnloadingConfirmStatus == "undefined" ||
        entity.isUnloadingConfirmStatus == null ||
        entity.isUnloadingConfirmStatus == 0
      ) {
        this.form.isUnloadingConfirmStatusMsg = "否";
      } else {
        this.form.isUnloadingConfirmStatusMsg = "是";
      }
      this.form.deliveryFeeDeserved = entity.deliveryFeeDeserved;
      this.form.taxPayFee = entity.taxPayFee;
      this.form.taxFee = entity.taxFee;

      if (entity.orderExtraFeeList && entity.orderExtraFeeList.length > 0) {
        for (const i in entity.orderExtraFeeList) {
          entity.orderExtraFeeList[i].extraPayType =
            entity.orderExtraFeeList[i].extraPayType + "";
        }
        this.form.orderExtraFeeList = entity.orderExtraFeeList;
      } else {
        this.form.orderExtraFeeList = [];
      }
      this.getExtraFeeTypeDict(entity.branchCode);
      this.loadImage();
    },
    loadImage() {
      OrderDetails(this.form.code).then(response => {
        if (response.status == 0) {
          this.form.fillImageUrl = response.data.fillImageInfoList;
          this.form.signImageUrl = response.data.signImageInfoList;
        }
      });
    },
    rejectFunc() {
      this.form.isUnloadingConfirm = 2;
      this.funcSubmit();
    },
    allowFunc() {
      this.form.isUnloadingConfirm = 1;
      this.funcSubmit();
    },
    async funcSubmit() {
      const remark = (this.form.abnormalRemark || "").trim();
      console.log(
        "判断异常=",
        this.form.isAbnormal,
        remark,
        !/[\u4e00-\u9fa5]/.test(remark)
      );
      if (
        this.form.isAbnormal == "1" &&
        remark &&
        !/[\u4e00-\u9fa5]/.test(remark)
      ) {
        this.$message.warning("备注中必须包含汉字");
        return;
      }
      this.form.abnormalFee = this.driftPriceType + this.form.abnormalFee;
      for (let item of this.form.orderExtraFeeList) {
        if (!item.extraFeeType || item.extraFeeAmount == "") {
          return this.$message.warning("必填项不能为空");
        }
      }
      this.form.orderExtraFeeList;
      if (this.abnormalImage && this.abnormalImage.length > 0) {
        this.form.abnormalImg = this.abnormalImage.join(",");
      } else {
        this.form.abnormalImg = "";
      }
      if (this.receiptImage && this.receiptImage.length > 0) {
        this.form.receiptImg = this.receiptImage.join(",");
      } else {
        this.form.receiptImg = "";
      }
      const data = JSON.parse(JSON.stringify(this.form));
      if (data.isAbnormal !== "1") {
        data.abnormalFee = "";
        data.abnormalRemark = "";
        data.abnormalImg = "";
      }
      if (data.isReceiptReturn !== "1") {
        data.receiptNum = "";
        data.receiptImg = "";
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (data.orderExtraFeeList && data.orderExtraFeeList.length > 0) {
            // let info = "";
            // for (const i in data.orderExtraFeeList) {
            //   const row = data.orderExtraFeeList[i];
            //   let lsInfo = "";
            //   if (row.extraFeeType === "" || row.extraFeeType === void 0) {
            //     lsInfo += "[费用名称]";
            //   }
            //   if (row.extraFeeAmount === "" || row.extraFeeAmount === void 0) {
            //     lsInfo += "[金额]";
            //   }
            //   if (row.extraPayType === "" || row.extraPayType === void 0) {
            //     lsInfo += "[收支类型]";
            //   }
            //   if (lsInfo !== "") {
            //     info += `\r\n第${Number(i) + 1}行`;
            //     info += lsInfo;
            //     info += "不能为空";
            //   }
            // }
            data.orderExtraFeeList = JSON.stringify(data.orderExtraFeeList);
          }
          const rLoading = this.openLoading();
          orderDetailFinish(data)
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
              delete data.orderExtraFeeList;
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    },
    handleAbnormalImgSuccess(res, file, fileList) {
      if (res.status == 500) {
        file.status = "fail";
        this.$message.error(res.msg);
        this.$refs.abnormalImgRef.uploadFiles = fileList.filter(
          item => item.uid != file.uid
        );
      } else {
        this.abnormalImage.push(res.data);
      }
    },
    handleAbnormalImgRemove(file, fileList) {
      this.abnormalImage.splice(
        this.abnormalImage.indexOf(file.response.data),
        1
      );
    },
    handleReceiptImgSuccess(res, file, fileList) {
      if (res.status == 500) {
        file.status = "fail";
        this.$message.error(res.msg);
        this.$refs.receiptImgRef.uploadFiles = fileList.filter(
          item => item.uid != file.uid
        );
      } else {
        this.receiptImage.push(res.data);
      }
    },
    handleReceiptImgRemove(file, fileList) {
      this.receiptImage.splice(
        this.receiptImage.indexOf(file.response.data),
        1
      );
    },
    beforeImgUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";
      const isLtnM = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,BMP,PNG 格式!");
        return false;
      }
      if (!isLtnM) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }

      // 获取token值，实时获取
      this.headers.Authorization = "Bearer " + getToken();
      return isJPG && isLtnM;
    },
    saveExtraFee(e) {
      let sum = 0;
      if (
        this.form.orderExtraFeeList &&
        this.form.orderExtraFeeList.length > 0
      ) {
        for (const i in this.form.orderExtraFeeList) {
          const extraFee = this.form.orderExtraFeeList[i];
          if (extraFee.extraPayType == "0") {
            extraFee.extraFeeAmount = extraFee.extraFeeAmount.replace(
              /([0-9]+\.[0-9]{2})[0-9\.]*/,
              "$1"
            );
            let extraFeeAmount = parseFloat(extraFee.extraFeeAmount);
            sum = ((sum * 100 + extraFeeAmount * 100) / 100).toFixed(2);
          } else if (extraFee.extraPayType == "1") {
            let extraFeeAmount = parseFloat(extraFee.extraFeeAmount);
            sum = ((sum * 100 - extraFeeAmount * 100) / 100).toFixed(2);
          }
        }
      }
      this.form.extraFee = sum;
    },
    insertEvent(rowIndex) {
      const record = {
        extraFeeType: "",
        extraFeeAmount: 0,
        extraPayType: "0",
        extraFeeRemark: ""
      };
      this.form.orderExtraFeeList.splice(rowIndex + 1, 0, record);
    },
    delRowEvent(row, rowIndex) {
      this.$confirm("确认刪除吗？")
        .then(_ => {
          this.form.orderExtraFeeList.splice(rowIndex, 1);
        })
        .catch(_ => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  float: right;
}
.positive_negative {
  display: flex;
  .positive_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d4d4d4;
    color: #ffffff;
    cursor: pointer;
  }
  .negative_btn {
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4186ef;
    color: #ffffff;
  }
}
.formTitle {
  text-align: right;
  padding-top: 10px;
  padding-right: 10px;
  .hx {
    color: #dd1515;
    margin-right: 4px;
  }
}
.hx {
  color: #dd1515;
  margin-right: 4px;
}
.pdt {
  padding-top: 3px;
}
</style>
